import React from "react";
import "notifications-pattern/dist/main.css";


export type ValidationError = {
  field: string;
  message: string;
  fieldRef?: React.RefObject<HTMLElement>;
};

type Props = {
  errors: ValidationError[];
  onErrorClick?: (error: ValidationError) => void;
};

const ErrorBanner: React.FC<Props> = ({ errors, onErrorClick }) => {
  if (!errors || errors.length === 0) return null;

  const handleErrorClick = (error: ValidationError) => {
    if (onErrorClick) {
      onErrorClick(error);
    } else if (error.fieldRef?.current) {
      error.fieldRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      error.fieldRef.current.focus();
    }
  };

  return (
    <div
      className="ds-notification p-6! border-border-red!"
      data-ds-version="1"
      data-ds-theme="vessel"
      role="alert"
      data-ds-variant="Error"
      aria-labelledby="ubt-error-banner-title"
    >
      <div className="ds-notification__icon">
        <img
          src="/assets/images/errorCircleSmall.svg"
          alt="Error"
          style={{ width: "40px", height: "40px" }}
        />
      </div>
      <div className="ds-notification__main-icon">
        <div className="ds-notification__header flex flex-col">
          <div
            className="ds-notification__heading font-bold text-xl"
            id="ubt-error-banner-title"
          >
            There {errors.length === 1 ? 'is an error' : 'are errors'} that need your attention:
          </div>
          <p className="p3 mb-0! mt-0!">
            Some fields contain invalid or missing information. Review the
            details below and update the highlighted fields to proceed.
          </p>
          <div className="ds-notification__body text-[16px]!">
            <div className="mt-2 flex flex-col gap-1">
              {errors.map((error, index) => (
                <button
                  key={`${error.field}-${index}`}
                  type="button"
                  onClick={() => handleErrorClick(error)}
                  className="text-kp-blue-dark underline text-left w-full bg-transparent border-none p-0 cursor-pointer hover:text-kp-blue"
                  aria-label={`Navigate to ${error.field}: ${error.message}`}
                >
                  <ul className="flex items-start list-disc m-0 my-0! ml-4">
                    <li>
                        <span className="text-base leading-6 text-kp-blue-dark">
                          {error.message}
                        </span>
                    </li>
                  </ul>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorBanner;
